import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {
    MvsApiCrudServiceCommentsInterface
} from "../../../../core/shared/service/api/mvs-api-crud-service-comments.interface";

@Injectable({
  providedIn: 'root'
})
export class TicketActionCommentService extends MvsCrudService implements MvsApiCrudServiceCommentsInterface{

  constructor(protected http: HttpClient) {
    super(http, MvsCrudService.baseUrl + '/tm/ticketActionComments');
  }

  getCommentAttribute(): string {
    return "comment";
  }

  hasCommentPinOption(): boolean {
    return false;
  }


  override getLinkedAttribute(objectType: string): string {
    if (objectType === "tm.TicketAction") {
      return "ticketAction";
    }

    return null;
  }

}
